import { Skeleton } from '../ui/skeleton';

const SolutionsLoader = () => {
  return (
    <div className="flex-1 overflow-x-hidden p-1 pb-[84px] pt-[70px] md:pt-[124px] animate-pulse">
      {/* Question Metadata */}
      <div className="bg-[var(--q3-surface-default)] mx-2 py-3 pl-6 pr-2 border-r border-l border-t border-[var(--q3-stroke-light)] rounded-t-[7px] flex items-center justify-between min-h-[48px]">
        <div className="flex flex-row items-center gap-x-3 flex-1 min-w-0">
          <Skeleton className="h-4 w-8 rounded" />
          <Skeleton className="h-5 w-12 rounded" />
          <Skeleton className="h-5 w-16 rounded" />
        </div>
        <div className="flex flex-row items-center gap-3 md:gap-4 flex-shrink-0 ml-4">
          <Skeleton className="h-7 w-16 rounded-full" />
          <Skeleton className="h-7 w-20 rounded-full" />
          <Skeleton className="h-7 w-16 rounded-full" />
        </div>
      </div>

      {/* Question Section */}
      <div className="relative bg-[var(--q3-surface-default)] border border-[var(--q3-stroke-light)] mx-2 p-6 overflow-hidden">
        <div className="space-y-4">
          <Skeleton className="h-5 w-3/4 rounded" />
          <Skeleton className="h-5 w-2/3 rounded" />
          <Skeleton className="h-5 w-1/2 rounded" />
        </div>
        {/* Options */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 py-6">
          {Array.from({ length: 4 }).map((_, i) => (
            <Skeleton key={i} className="h-12 w-full rounded-lg" />
          ))}
        </div>
      </div>

      {/* Solution Section */}
      <div className="bg-[var(--q3-surface-default)] border-l border-r border-b border-[var(--q3-stroke-light)] mx-2 p-6 pr-0 overflow-hidden">
        <div className="mb-6 flex flex-col gap-4">
          <div className="flex flex-col items-start gap-x-2 min-w-0 flex-1">
            <Skeleton className="h-4 w-24 rounded" />
            <Skeleton className="h-4 w-40 rounded" />
          </div>
          <div className="space-y-2">
            <Skeleton className="h-4 w-28 rounded" />
            <Skeleton className="h-16 w-full rounded" />
          </div>
        </div>
      </div>

      {/* Tags Section */}
      <div className="bg-[var(--q3-surface-default)] border-l border-r border-b border-[var(--q3-stroke-light)] mx-2 p-6">
        <Skeleton className="h-5 w-48 rounded" />
        <div className="flex flex-row gap-2 mt-3">
          {Array.from({ length: 3 }).map((_, i) => (
            <Skeleton key={i} className="h-6 w-20 rounded-full" />
          ))}
        </div>
      </div>

      {/* Analytics + Journey */}
      <div className="bg-[var(--q3-surface-default)] border-l border-r border-b rounded-b-[7px] border-[var(--q3-stroke-light)] mx-2 p-4 md:p-6 space-y-4">
        <Skeleton className="h-24 w-full rounded-lg" />
        <Skeleton className="h-28 w-full rounded-lg" />
      </div>
    </div>
  );
};

export default SolutionsLoader;
